import UserProfile from '@ditmac/metronic-partials/lib/layout/UserProfile';
import React from 'react';

export default class Topbar extends React.Component {
  render() {
    return (
      <div className="kt-header__topbar">
        <UserProfile showAvatar={true} showHi={true} showBadge={false} />
      </div>
    );
  }
}
